const caso = [
	{
		titulo:"MMSS HOMBRO",
		abordajes:[
			{
				titulo: "1. ABORDAJE ANTERIOR. EJE CORTO. TROQUITER, TROQUIN Y CORREDERA BICIPITAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 1_01.jpg","Hombro-Abordaje 1_02.jpg","Hombro-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación con los hombros en posición anatómica, codo en flexión de 90º y mano supinada sobre los muslos.",
					opciones:["hombro posiciones 1.jpg","hombro posiciones 2.jpg","hombro posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Realiza un movimiento cráneo caudal sobre la corredera bicipital del humero con la sonda en eje corto sobre el tendón largo del bíceps.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.478,y:0.471},
						fin:{x:0.484,y:0.268},
						iniImg:0,
						finImg:70,
						atlas:[{pos:20,atlas:"/hombro/atlas/hombro01_atlas01.svg"},{pos:64,atlas:"/hombro/atlas/hombro01_atlas02.svg"}],
					}
				],
				fondo:"hombro.jpg",
				escala: 0.80,
				giro: 4.7123,
				ruido:"/ruido_700x700",
				ecografia:"/hombro/01",
			},
			{
				titulo: "2. ABORDAJE ANTERIOR. EJE LARGO. TENDÓN LARGO DEL BÍCEPS.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 1_01.jpg","Hombro-Abordaje 1_02.jpg","Hombro-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación con los hombros en posición anatómica, codo en flexión de 90º y mano supinada sobre los muslos.",
					opciones:["hombro posiciones 1.jpg","hombro posiciones 2.jpg","hombro posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Realiza cambio de eje corto a largo desde la exploración anterior.",
				recorrido:[
					{
						tipo:"giro",
						x:0.478,
						y:0.267,
						ini:4.7123,
						fin:0,
						iniImg:0,
						finImg:78,
						atlas:[{pos:66,atlas:"/hombro/atlas/hombro02_atlas01.svg"}],
					}
				],
				fondo:"hombro.jpg",
				escala: 0.80,
				giro: 4.7123,
				ruido:"/ruido_700x700",
				ecografia:"/hombro/02",
			},
			{
				titulo: "3. ABORDAJE ANTERIOR. EJE LARGO. TENDÓN PECTORAL MAYOR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 1_01.jpg","Hombro-Abordaje 1_02.jpg","Hombro-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación con los hombros en posición anatómica, codo en flexión de 90º y mano supinada sobre los muslos.",
					opciones:["hombro posiciones 1.jpg","hombro posiciones 2.jpg","hombro posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda en eje largo sobre el tendón tomando como referencia el pliegue cutáneo axilar anterior, deslizando la sonda a craneal y caudal.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.484,y:0.395},
						fin:{x:0.651,y:0.395},
						iniImg:0,
						finImg:116,
						atlas:[{pos:83,atlas:"/hombro/atlas/hombro03_atlas01.svg"}],
					}
				],
				fondo:"hombro.jpg",
				escala: 0.80,
				giro: 4.7123,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/03",
			},
			{
				titulo: "4. ABORDAJE ANTERIOR. EJE LARGO. TENDÓN SUBESCAPULAR Y REGIÓN SUBCORACOIDEA. TEST DINÁMICO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 1_01.jpg","Hombro-Abordaje 1_02.jpg","Hombro-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación con los hombros en posición anatómica, codo en ﬂexión de 90º y mano supinada sobre los muslos.",
					opciones:["hombro posiciones 1.jpg","hombro posiciones 2.jpg","hombro posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la coracoides y cabeza humeral. Si mover la sonda solicita realización de rotación externa e interna de hombro.",
				recorrido:[
					{
						tipo:"din",
						x: 0.682,
						y: 0.17,
						iniImg:0,
						finImg:110,
						atlas:[{pos:4,atlas:"/hombro/atlas/hombro04_atlas01.svg"},{pos:106,atlas:"/hombro/atlas/hombro04_atlas02.svg"}],
					}
				],
				fondo:"/hombro_04",
				escala: 0.46,
				giro: 4.7123,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/04",
			},
			{
				titulo: "5. ABORDAJE ANTERIOR. EJE CORTO. CORACOBRAQUIAL Y CABEZA CORTA BÍCEPS.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 1_01.jpg","Hombro-Abordaje 1_02.jpg","Hombro-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación con los hombros en posición anatómica, codo en ﬂexión de 90º y mano supinada sobre los muslos.",
					opciones:["hombro posiciones 1.jpg","hombro posiciones 2.jpg","hombro posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la coracoides en eje corto sobre inserción común de coracobraquial y cabeza corta de bíceps (referencia Apóﬁsis Coracoides). Desliza la sonda hacia caudal siguiendo el trayecto de estos vientres musculares.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.585,y:0.314},
						fin:{x:0.525,y:0.581},
						iniImg:0,
						finImg:191,
						atlas:[{pos:9,atlas:"/hombro/atlas/hombro05_atlas01.svg"},{pos:70,atlas:"/hombro/atlas/hombro05_atlas02.svg"},
							{pos:149,atlas:"/hombro/atlas/hombro05_atlas03.svg"}],
					}
				],
				fondo:"hombro.jpg",
				escala: 0.80,
				giro: 289/180*Math.PI,
				ruido:"/ruido_1000x700",
				ecografia:"/hombro/05",
			},
			{
				titulo: "6. ABORDAJE CRANEAL. EJE LATEROMEDIAL. ARTICULACIÓN ACROMIOCLAVICULAR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 1_01.jpg","Hombro-Abordaje 1_02.jpg","Hombro-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación con los hombros en posición anatómica, codo en ﬂexión de 90º y mano supinada sobre los muslos.",
					opciones:["hombro posiciones 1.jpg","hombro posiciones 2.jpg","hombro posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la articulación acromio clavicular y realiza ligeros movimientos antero posteriores.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.47,y:0.25},
						fin:{x:0.504,y:0.374},
						iniImg:0,
						finImg:88,
						atlas:[{pos:40,atlas:"/hombro/atlas/hombro06_atlas01.svg"}],
					}
				],
				fondo:"hombro cenital.jpg",
				escala: 1.14,
				giro: 4.3963,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/06",
			},
			{
				titulo: "7. ABORDAJE ANTERIOR. EJE LARGO. TENDÓN SUPRAESPINOSO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 7_01.jpg","Hombro-Abordaje 7_02.jpg","Hombro-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el hombro a explorar en rotación interna y mano en la región lumbar.",
					opciones:["hombro brazo atras posiciones 1.jpg","hombro brazo atras posiciones 2.jpg","hombro brazo atras posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del acromion con la sonda en eje largo sobre el tendón del supraespinoso. Se realizan deslizamientos latero-mediales sobre el muñón del hombro.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.605,y:0.257},
						fin:{x:0.485,y:0.232},
						iniImg:0,
						finImg:84,
						atlas:[{pos:73,atlas:"/hombro/atlas/hombro07_atlas01.svg"}],
					}
				],
				fondo:"hombro brazo atras.jpg",
				escala: 0.73,
				giro: 0.2548,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/07",
			},
			{
				titulo: "8. ABORDAJE POSTERIOR. EJE CORTO. INFRAESPINOSO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 8_01.jpg","Hombro-Abordaje 8_02.jpg","Hombro-Abordaje 8_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el hombro a explorar en rotación interna y mano en la región lumbar.",
					opciones:["hombro espalda posiciones 1.jpg","hombro espalda posiciones 2.jpg","hombro espalda posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara posterior del hombro en eje corto sobre infraespinoso con la referencia de la espina de la escápula. Deslizaremos la sonda hacia el borde axilar de la escápula hasta encontrar la formación del tendón intramuscular del infraespinoso.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.422,y:0.207},
						fin:{x:0.537,y:0.2},
						iniImg:0,
						finImg:78,
						atlas:[{pos:1,atlas:"/hombro/atlas/hombro08_atlas01.svg"},{pos:19,atlas:"/hombro/atlas/hombro08_atlas02.svg"},
							{pos:72,atlas:"/hombro/atlas/hombro08_atlas03.svg"}],
					}
				],
				fondo:"hombro espalda.jpg",
				escala: 0.60,
				giro: 6.2700,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/08",
			},
			{
				titulo: "9. ABORDAJE POSTERIOR. EJE CORTO. REDONDO MENOR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 8_01.jpg","Hombro-Abordaje 8_02.jpg","Hombro-Abordaje 8_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el hombro a explorar en rotación interna y mano en la región lumbar.",
					opciones:["hombro espalda posiciones 1.jpg","hombro espalda posiciones 2.jpg","hombro espalda posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara posterior del hombro en eje corto sobre infraespinoso con la referencia de la espina de la escápula y deslizar la sonda hacia el borde axilar de la escápula hasta encontrar la formación del tendón intramusucular del infraespinoso. En ese momento deslizar la sonda hacia caudal y observaremos la misma composición, pero del redondo menor.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.425,y:0.204},
						fin:{x:0.535,y:0.2},
						iniImg:0,
						finImg:78,
					},
					{
						tipo:"mov",
						ini:{x:0.535,y:0.2},
						fin:{x:0.534,y:0.26},
						iniImg:79,
						finImg:120,
						atlas:[{pos:91,atlas:"/hombro/atlas/hombro09_atlas01.svg"},{pos:119,atlas:"/hombro/atlas/hombro09_atlas02.svg"}],
					}
				],
				fondo:"hombro espalda.jpg",
				escala: 0.60,
				giro: 0.0371,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/09",
			},
			{
				titulo: "10. ABORDAJE POSTERIOR. EJE LARGO. INFRAESPINOSO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 8_01.jpg","Hombro-Abordaje 8_02.jpg","Hombro-Abordaje 8_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el hombro a explorar en rotación interna y mano en la región lumbar.",
					opciones:["hombro espalda posiciones 1.jpg","hombro espalda posiciones 2.jpg","hombro espalda posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara posterior del hombro en eje corto sobre supraespinoso y redondo menor con la referencia de la espina de la escápula. Se parte de la exploración anterior cambiando de eje corto a eje largo sobre el tendón mas grueso y cercano a la espina.",
				recorrido:[
					{
						tipo:"giro",
						x:0.537,
						y:0.2,
						ini:0.0270,
						fin:1.5978,
						iniImg:0,
						finImg:90,
						atlas:[{pos:2,atlas:"/hombro/atlas/hombro10_atlas01.svg"},{pos:56,atlas:"/hombro/atlas/hombro10_atlas02.svg"}],
					}
				],
				fondo:"hombro espalda.jpg",
				escala: 0.60,
				giro: 0.0270,
				ruido:"/ruido_1120x700",
				ecografia:"/hombro/10",
			},
			{
				titulo: "11. ABORDAJE POSTERIOR. EJE LARGO. REDONDO MENOR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Hombro-Abordaje 8_01.jpg","Hombro-Abordaje 8_02.jpg","Hombro-Abordaje 8_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el hombro a explorar en rotación interna y mano en la región lumbar.",
					opciones:["hombro espalda posiciones 1.jpg","hombro espalda posiciones 2.jpg","hombro espalda posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara posterior del hombro en eje corto sobre supraespinoso y redondo menor con la referencia de la espina de la espina de la escápula. Se parte de la exploración anterior cambiando de eje corto a eje largo sobre el tendón más delgado y caudal al anterior.",
				recorrido:[
					{
						tipo:"giro",
						x:0.537,
						y:0.251,
						ini:0.0270,
						fin:1.5978,
						iniImg:0,
						finImg:90,
						atlas:[{pos:89,atlas:"/hombro/atlas/hombro11_atlas01.svg"}],
					}
				],
				fondo:"hombro espalda.jpg",
				escala: 0.60,
				ruido:"/ruido_1120x700",
				giro: 0.0270,
				ecografia:"/hombro/11",
			}
		] 
	},
	{
		titulo:"MMSS CODO",
		abordajes:[
			{
				titulo: "1. ABORDAJE ANTERIOR. EJE CORTO. TRÓCLEA, CÓNDILO Y RECESO ANTERIOR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 1_01.jpg","Codo-Abordaje 1_02.jpg","Codo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara anterior al ecografista.",
					opciones:["codo frontal posiciones 1.jpg","codo frontal posiciones 2.jpg","codo frontal posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del tercio distal del brazo en eje corto sobre los flexores del codo y desliza hacia caudal hasta observar los relieves óseos de la paleta humeral.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.487,y:0.057},
						fin:{x:0.495,y:0.211},
						iniImg:0,
						finImg:106,
						atlas:[{pos:106,atlas:"/codo/atlas/codo01_atlas01.svg"}],
					}
				],
				fondo:"codo frontal.jpg",
				escala: 1.05,
				giro: 4.6509,
				ruido:"/ruido_840x700",
				ecografia:"/codo/01",
			},
			{
				titulo: "2. ABORDAJE ANTERIOR. EJE CORTO. RECORRIDO NERVIO MEDIANO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 1_01.jpg","Codo-Abordaje 1_02.jpg","Codo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara anterior al ecografista.",
					opciones:["codo frontal posiciones 1.jpg","codo frontal posiciones 2.jpg","codo frontal posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del tercio distal del brazo en eje corto sobre los flexores del codo y desliza hacia caudal hasta observar los relieves óseos de la paleta humeral. Desde esta posición se evidencia el nervio mediano y se persigue hacia caudal.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.492,y:0.208},
						fin:{x:0.492,y:0.325},
						iniImg:0,
						finImg:85,
						atlas:[{pos:82,atlas:"/codo/atlas/codo02_atlas01.svg"}],
					}
				],
				fondo:"codo frontal.jpg",
				escala: 1.05,
				giro: 1.5432,
				ruido:"/ruido_840x700",
				ecografia:"/codo/02",
			},
			{
				titulo: "3. ABORDAJE ANTERIOR. EJE LARGO. INTERLÍNEA HÚMERO-RADIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 1_01.jpg","Codo-Abordaje 1_02.jpg","Codo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara anterior al ecografista.",
					opciones:["codo frontal posiciones 1.jpg","codo frontal posiciones 2.jpg","codo frontal posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del tercio distal del brazo en eje corto sobre los flexores del codo y desliza hacia caudal hasta observar los relieves óseos de la paleta humeral. Desde esta posición se cambia de eje corto a largo visualizando la cabeza radial.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.425,y:0.165},
						fin:{x:0.49,y:0.167},
						iniImg:0,
						finImg:43,
					},
					{
						tipo:"giro",
						x:0.49,
						y:0.167,
						ini:4.7123,
						fin:0,
						iniImg:43,
						finImg:133,
						atlas:[{pos:130,atlas:"/codo/atlas/codo03_atlas01.svg"}],
					}
				],
				fondo:"codo frontal.jpg",
				escala: 1.05,
				giro: 4.7123,
				ruido:"/ruido_840x700",
				ecografia:"/codo/03",
			},
			{
				titulo: "4. ABORDAJE ANTERIOR. EJE CORTO. NERVIO RADIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 1_01.jpg","Codo-Abordaje 1_02.jpg","Codo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara anterior al ecografista.",
					opciones:["codo frontal posiciones 1.jpg","codo frontal posiciones 2.jpg","codo frontal posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del tercio distal del brazo en eje corto sobre los flexores del codo y desliza hacia caudal hasta observar los relieves óseos de la paleta humeral. Desde esta posición se observa el nervio radial siguiéndolo hasta que profundiza en el Músculo Supinador.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.422,y:0.155},
						fin:{x:281/700,y:30/700},
						iniImg:0,
						finImg:96,
						atlas:[{pos:94,atlas:"/codo/atlas/codo04_atlas01.svg"},{pos:26,atlas:"/codo/atlas/codo04_atlas02.svg"}],
					}
				],
				fondo:"codo frontal.jpg",
				escala: 1.05,
				giro: 4.7123,
				ruido:"/ruido_840x700",
				ecografia:"/codo/04",
			},
			{
				titulo: "5. ABORDAJE ANTERIOR. EJE LARGO. NERVIO RADIAL, ARCADA DE FROHSE.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 1_01.jpg","Codo-Abordaje 1_02.jpg","Codo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara anterior al ecografista.",
					opciones:["codo frontal posiciones 1.jpg","codo frontal posiciones 2.jpg","codo frontal posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del tercio distal del brazo en eje corto sobre los flexores del codo y desliza hacia caudal hasta observar los relieves óseos de la paleta humeral. Desde esta posición se observa el nervio radial siguiéndolo hasta que profundiza en el Músculo Supinador cambiando en ese momento a eje largo sobre el nervio.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.425,y:0.17},
						fin:{x:0.394,y:0.274},
						iniImg:0,
						finImg:76,
						atlas:[{pos:5,atlas:"/codo/atlas/codo05_atlas01.svg"},{pos:62,atlas:"/codo/atlas/codo05_atlas02.svg"}],
					},
					{
						tipo:"giro",
						x:0.394,
						y:0.274,
						ini:3*Math.PI/2,
						fin:2*Math.PI,
						iniImg:76,
						finImg:166,
						atlas:[{pos:165,atlas:"/codo/atlas/codo05_atlas03.svg"}],
					}
				],
				fondo:"codo frontal.jpg",
				escala: 1.05,
				giro: 3*Math.PI/2,
				ruido:"/ruido_840x700",
				ecografia:"/codo/05",
			},
			{
				titulo: "6. ABORDAJE ANTERIOR. EJE LARGO. INTERLÍNEA HUMERO-CUBITAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 1_01.jpg","Codo-Abordaje 1_02.jpg","Codo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara anterior al ecografista.",
					opciones:["codo frontal posiciones 1.jpg","codo frontal posiciones 2.jpg","codo frontal posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la cara anterior del tercio distal del brazo en eje corto sobre los flexores del codo y desliza hacia caudal hasta observar los relieves óseos de la paleta humeral. Desde esta posición se cambia de eje corto a largo visualizando tróclea humeral.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:345/700,y:147/700},
						fin:{x:371/700,y:145/700},
						iniImg:0,
						finImg:24,
					},
					{
						tipo:"giro",
						x:371/700,
						y:145/700,
						ini:4.6622,
						fin:6.2330,
						iniImg:25,
						finImg:114,
						atlas:[{pos:101,atlas:"/codo/atlas/codo06_atlas01.svg"}],
					}
				],
				fondo:"codo frontal.jpg",
				escala: 1.05,
				giro: 4.6622,
				ruido:"/ruido_840x700",
				ecografia:"/codo/06",
			},
			{
				titulo: "7. ABORDAJE MEDIAL. EJE LARGO. LIGAMENTO COLATERAL MEDIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 7_01.jpg","Codo-Abordaje 7_02.jpg","Codo-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara medial del codo al ecografista.",
					opciones:["codo frontal rotacion posiciones 1.jpg","codo frontal rotacion posiciones 2.jpg","codo frontal rotacion posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la epitróclea en eje largo sobre el ligamento colateral medial, la sonda se coloca siguiendo un plano coronal con respecto al brazo y antebrazo.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:435/700,y:133/700},
						fin:{x:422/700,y:123/700},
						iniImg:0,
						finImg:13,
						atlas:[{pos:13,atlas:"/codo/atlas/codo07_atlas01.svg"}],
					}
				],
				fondo:"codo frontal rotacion.jpg",
				escala: 0.64,
				giro: 0,
				ruido:"/ruido_840x700",
				ecografia:"/codo/07",
			},
			{
				titulo: "8. ABORDAJE MEDIAL. EJE LARGO. INSERCIÓN MÚSCULOS EPITROCLEARES.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 7_01.jpg","Codo-Abordaje 7_02.jpg","Codo-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en extensión apoyado sobre la camilla ofreciendo la cara medial del codo al ecografista.",
					opciones:["codo frontal rotacion posiciones 1.jpg","codo frontal rotacion posiciones 2.jpg","codo frontal rotacion posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la epitróclea en eje largo sobre el ligamento colateral medial, la sonda se coloca siguiendo un plano coronal con respecto al brazo y antebrazo. Desde esta posición sin perder la visión de la epitróclea se pivota la sonda hacia anterior observando la alineación de las fibras tendinosas.",
				recorrido:[
					{
						tipo:"giro",
						mod:"lat",
						x:0.578571429,
						y:0.155714286,
						ini:6.06145483,
						fin:6.80089543,
						iniImg:0,
						finImg:30,
						atlas:[{pos:30,atlas:"/codo/atlas/codo08_atlas01.svg"}],
					}
				],
				fondo:"codo frontal rotacion.jpg",
				escala: 0.64,
				giro: 6.06145483,
				ruido:"/ruido_840x700",
				ecografia:"/codo/08",
			},
			{
				titulo: "9. ABORDAJE LATERAL. EJE LARGO. INSERCIÓN MÚSCULOS EPICONDÍLEOS.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 9_01.jpg","Codo-Abordaje 9_02.jpg","Codo-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en flexión de 90º apoyado en la camilla, ofreciendo la cara lateral del codo al ecografista.",
					opciones:["codo frontal flexion posiciones 1.jpg","codo frontal flexion posiciones 2.jpg","codo frontal flexion posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el epicóndilo en eje largo sobre el tendón de los epicondíleos con la referencia ósea del epicóndilo. La sonda se coloca siguiendo un plano coronal con respecto al brazo y antebrazo.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.148,y:0.514},
						fin:{x:0.147,y:0.548},
						iniImg:0,
						finImg:22,
						atlas:[{pos:7,atlas:"/codo/atlas/codo09_atlas01.svg"}],
					}
				],
				fondo:"codo frontal flexion.jpg",
				escala: 0.88,
				giro: 4.7767,
				ruido:"/ruido_1120x700",
				ecografia:"/codo/09",
			},
			{
				titulo: "10. ABORDAJE POSTERIOR. EJE LARGO. TENDÓN DEL TRÍCEPS.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 10_01.jpg","Codo-Abordaje 10_02.jpg","Codo-Abordaje 10_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en flexión de 90º apoyada la palma de la mano en la camilla, ofreciendo la cara posterior del codo al 	ecografista (paciente dando la espalda parcialmente al ecografista).",
					opciones:["codo superior flexion posiciones 1.jpg","codo superior flexion posiciones 2.jpg","codo superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el olécranon sobre el tendón de tendón del tríceps en eje largo sobre este.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.318,y:0.585},
						fin:{x:0.344,y:0.59},
						iniImg:0,
						finImg:17,
						atlas:[{pos:17,atlas:"/codo/atlas/codo10_atlas01.svg"}],
					}
				],
				fondo:"codo superior flexion.jpg",
				escala: 0.90,
				giro: 0.1719,
				ruido:"/ruido_1000x700",
				ecografia:"/codo/10",
			},
			{
				titulo: "11. ABORDAJE POSTERIOR. EJE CORTO. NERVIO CUBITAL EN CANAL DE OSBORNE.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la 	sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Codo-Abordaje 10_01.jpg","Codo-Abordaje 10_02.jpg","Codo-Abordaje 10_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el codo a explorar en flexión de 90º apoyada la palma de la mano en la camilla, ofreciendo la cara posterior del codo al 	ecografista (paciente dando la espalda parcialmente al ecografista).",
					opciones:["codo superior flexion posiciones 1.jpg","codo superior flexion posiciones 2.jpg","codo superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el olécranon sobre el tendón de tendón del tríceps en eje largo sobre este. Desde esta posición se pivota sobre el olécranon apoyando el resto de la sonda sobre epitróclea. Bajo la sonda será visible el nervio apoyado sobre epitróclea.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.31,y:0.555},
						fin:{x:0.29,y:0.565},
						iniImg:0,
						finImg:15,
						atlas:[{pos:10,atlas:"/codo/atlas/codo11_atlas01.svg"}],
					}
				],
				fondo:"codo superior flexion.jpg",
				escala: 0.90,
				giro: 5.9815,
				ruido:"/ruido_1120x700",
				ecografia:"/codo/11",
			}
		] 
	},
	{
		titulo:"MMSS CARPO",
		abordajes:[
			{
				titulo: "1. ABORDAJE ANTERIOR. EJE CORTO. ENTRADA TÚNEL CARPIANO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 1_01.jpg","Carpo-Abordaje 1_02.jpg","Carpo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en supinación de antebrazo, ofreciendo la cara anterior del carpo al ecografista.",
					opciones:["carpo superior posiciones 1.jpg","carpo superior posiciones 2.jpg","carpo superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el pisiforme y escafoides.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.521,y:0.478},
						fin:{x:0.527,y:0.504},
						iniImg:0,
						finImg:16,
						atlas:[{pos:1,atlas:"/carpo/atlas/carpo01_atlas01.svg"}],
					}
				],
				fondo:"carpo superior.jpg",
				escala: 1.01,
				giro: 4.5095,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/01",
			},
			{
				titulo: "2. ABORDAJE ANTERIOR. EJE LARGO. NERVIO MEDIANO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 1_01.jpg","Carpo-Abordaje 1_02.jpg","Carpo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en supinación de antebrazo, ofreciendo la cara anterior del carpo al ecografista.",
					opciones:["carpo superior posiciones 1.jpg","carpo superior posiciones 2.jpg","carpo superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el pisiforme y escafoides. Desde esta posición se localiza el nervio mediano y se cambia a eje largo visualizándolo en todo momento.",
				recorrido:[
					{
						tipo:"giro",
						x:0.525,
						y:0.5,
						ini:4.5043,
						fin:6.0751,
						iniImg:0,
						finImg:90,
						atlas:[{pos:89,atlas:"/carpo/atlas/carpo02_atlas01.svg"}],
					}
				],
				fondo:"carpo superior.jpg",
				escala: 1.01,
				giro: 4.5043,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/02",
			},
			{
				titulo: "3. ABORDAJE ANTERIOR. EJE CORTO. NERVIO CUBITAL EN CANAL DE GUYÓN.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 1_01.jpg","Carpo-Abordaje 1_02.jpg","Carpo-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en supinación de antebrazo, ofreciendo la cara anterior del carpo al ecografista.",
					opciones:["carpo superior posiciones 1.jpg","carpo superior posiciones 2.jpg","carpo superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el pisiforme y escafoides. Desde esta posición se hace énfasis en la arteria cubital junto al pisiforme observando el nervio junto a esta.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:412/700,y:28/700},
						fin:{x:375/700,y:330/700},
						iniImg:0,
						finImg:318,
						atlas:[{pos:2,atlas:"/carpo/atlas/carpo03_atlas01.svg"}],
					}
				],
				fondo:"carpo superior.jpg",
				escala: 1.01,
				giro: 270/180*Math.PI,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/03",
			},
			{
				titulo: "4. ABORDAJE POSTERIOR. EJE CORTO. TUBÉRCULO DE LISTER.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 4_01.jpg","Carpo-Abordaje 4_02.jpg","Carpo-Abordaje 4_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo superior palma abajo posiciones 1.jpg","carpo superior palma abajo posiciones 2.jpg","carpo superior palma abajo posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.521,y:0.261},
						fin:{x:0.521,y:0.285},
						iniImg:0,
						finImg:17,
						atlas:[{pos:13,atlas:"/carpo/atlas/carpo04_atlas01.svg"}],
					}
				],
				fondo:"carpo superior palma abajo.jpg",
				escala: 1.06,
				giro: 1.5212,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/04",
			},
			{
				titulo: "5. ABORDAJE POSTERIOR. EJE CORTO. PRIMER COMPARTIMENTO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 5_01.jpg","Carpo-Abordaje 5_02.jpg","Carpo-Abordaje 5_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo lateral posiciones 1.jpg","carpo lateral posiciones 2.jpg","carpo lateral posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio. Desde esta posición se desliza la sonda hacia radial hasta ver el primer compartimento.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.424,y:0.211},
						fin:{x:0.525,y:0.207},
						iniImg:0,
						finImg:68,
						atlas:[{pos:53,atlas:"/carpo/atlas/carpo05_atlas01.svg"}],
					}
				],
				fondo:"carpo lateral.jpg",
				escala: 1.38,
				giro: 1.5708,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/05",
			},
			{
				titulo: "6. ABORDAJE POSTERIOR. EJE CORTO. SEGUNDO COMPARTIMENTO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 5_01.jpg","Carpo-Abordaje 5_02.jpg","Carpo-Abordaje 5_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo lateral posiciones 1.jpg","carpo lateral posiciones 2.jpg","carpo lateral posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio. Desde esta posición se desliza la sonda hacia radial hasta ver el segundo compartimento.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.525,y:0.207},
						fin:{x:0.475,y:0.21},
						iniImg:0,
						finImg:33,
						atlas:[{pos:23,atlas:"/carpo/atlas/carpo06_atlas01.svg"}],
					}
				],
				fondo:"carpo lateral.jpg",
				escala: 1.38,
				giro: 1.5708,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/06",
			},
			{
				titulo: "7. ABORDAJE POSTERIOR. EJE CORTO. TERCER COMPARTIMENTO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 7_01.jpg","Carpo-Abordaje 7_02.jpg","Carpo-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo lateral posiciones 1.jpg","carpo lateral posiciones 2.jpg","carpo lateral posiciones 3.jpg"],
					valida:1,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio. Desde esta posición se desliza la sonda hacia cubital hasta ver el tercer compartimento.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.521,y:0.285},
						fin:{x:0.551,y:0.282},
						iniImg:0,
						finImg:14,
						atlas:[{pos:2,atlas:"/carpo/atlas/carpo07_atlas01.svg"}],
					}
				],
				fondo:"carpo superior palma abajo.jpg",
				escala: 1.06,
				giro: 1.5261,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/07",
			},
			{
				titulo: "8. ABORDAJE POSTERIOR. EJE CORTO. CUARTO COMPARTIMENTO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 7_01.jpg","Carpo-Abordaje 7_02.jpg","Carpo-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo lateral posiciones 1.jpg","carpo lateral posiciones 2.jpg","carpo lateral posiciones 3.jpg"],
					valida:1,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio. Desde esta posición se desliza la sonda hacia cubital hasta ver el cuarto compartimento.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.528,y:0.284},
						fin:{x:0.495,y:0.288},
						iniImg:0,
						finImg:20,
						atlas:[{pos:12,atlas:"/carpo/atlas/carpo08_atlas01.svg"}],
					}
				],
				fondo:"carpo superior palma abajo.jpg",
				escala: 1.06,
				giro: 1.4704,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/08",
			},
			{
				titulo: "9. ABORDAJE POSTERIOR. EJE CORTO. QUINTO COMPARTIMENTO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 7_01.jpg","Carpo-Abordaje 7_02.jpg","Carpo-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo lateral posiciones 1.jpg","carpo lateral posiciones 2.jpg","carpo lateral posiciones 3.jpg"],
					valida:1,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio. Desde esta posición se desliza la sonda hacia cubital hasta ver el quinto compartimento.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.498,y:0.287},
						fin:{x:0.462,y:0.29},
						iniImg:0,
						finImg:24,
						atlas:[{pos:23,atlas:"/carpo/atlas/carpo09_atlas01.svg"}],
					}
				],
				fondo:"carpo superior palma abajo.jpg",
				escala: 1.06,
				giro: 1.5046,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/09",
			},
			{
				titulo: "10. ABORDAJE POSTERIOR. EJE CORTO. SEXTO COMPARTIMENTO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Carpo-Abordaje 7_01.jpg","Carpo-Abordaje 7_02.jpg","Carpo-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación el carpo a explorar en la camilla en pronación de antebrazo, ofreciendo la cara posterior del carpo al ecografista.",
					opciones:["carpo lateral posiciones 1.jpg","carpo lateral posiciones 2.jpg","carpo lateral posiciones 3.jpg"],
					valida:1,
				},
				ejercicio: "Posiciona la sonda sobre el tubérculo de Lister del radio. Desde esta posición se desliza la sonda hacia cubital hasta ver el sexto compartimento. Sin perder de vista el tendón del extensor cubital del carpo se cambia a eje largo y se le pide al paciente que haga desviaciones cubitales y radiales para observar el movimiento del tendón.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:365/700,y:203/700},
						fin:{x:320/700,y:207/700},
						iniImg:0,
						finImg:43,
					},{
						tipo:"giro",
						ini: 88/180*Math.PI,
						fin: 178/180*Math.PI,
						iniImg:44,
						finImg:132,
						atlas:[{pos:44,atlas:"/carpo/atlas/carpo10_atlas01.svg"}],
					}
				],
				fondo:"carpo superior palma abajo.jpg",
				escala: 1.06,
				giro: 88/180*Math.PI,
				ruido:"/ruido_1120x700",
				ecografia:"/carpo/10",
			}
		]
	},
	{
		titulo:"MMII CADERA",
		abordajes:[
			{
				titulo: "1. ABORDAJE MEDIAL. EJE CORTO. MÚSCULOS ABDUCTORES: GRÁCIL, ABDUCTOR LARGO, MENOR Y MAYOR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 1_01.jpg","Cadera-Abordaje 1_02.jpg","Cadera-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con la cadera en rotación externa y ligera abducción. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar.",
					opciones:["cadera superior lateral posiciones 1.jpg","cadera superior lateral posiciones 2.jpg","cadera superior lateral posiciones 3.jpg"],
					valida:1,
				},
				ejercicio: "Posiciona la sonda sobre los músculos adductores en eje corto con respecto a estos.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.437,y:0.557},
						fin:{x:0.748,y:0.298},
						iniImg:0,
						finImg:234,
						atlas:[{pos:32,atlas:"/cadera/atlas/cadera01_atlas01.svg"},{pos:229,atlas:"/cadera/atlas/cadera01_atlas02.svg"}],
					}
				],
				fondo:"cadera superior lateral.jpg",
				escala: 0.72,
				giro: 5.5613,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/01",
			},
			{
				titulo: "2. ABORDAJE ANTERIOR. EJE CORTO. PAQUETE VÁSCULO NERVIOSO. TRIÁNGULO DE SCARPA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 2_01.jpg","Cadera-Abordaje 2_02.jpg","Cadera-Abordaje 2_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con la cadera en posición anatómica. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar.",
					opciones:["cadera superior posiciones 1.jpg","cadera superior posiciones 2.jpg","cadera superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda en la cara anterior de la coxofemoral movilizando la sonda cráneo caudalmente en eje corto sobre los vasos, cerca de la línea inguinal.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.481,y:0.295},
						fin:{x:0.431,y:0.294},
						iniImg:0,
						finImg:33,
						atlas:[{pos:13,atlas:"/cadera/atlas/cadera02_atlas01.svg"}],
					}
				],
				fondo:"cadera superior.jpg",
				escala: 0.79,
				giro: 3.1415,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/02",
			},
			{
				titulo: "3. ABORDAJE ANTERIOR. EJE CORTO. PAQUETE VÁSCULO NERVIOSO. VALORACIÓN PERMEABILIDAD DE LOS VASOS.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 2_01.jpg","Cadera-Abordaje 2_02.jpg","Cadera-Abordaje 2_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con la cadera en posición anatómica. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar.",
					opciones:["cadera superior posiciones 1.jpg","cadera superior posiciones 2.jpg","cadera superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda en la cara anterior de la coxofemoral movilizando la sonda cráneo caudalmente en eje corto sobre los vasos, cerca de la línea inguinal. Desde esta posición se realizan compresiones y descompresiones observando el colapso de las venas en la compresión y llenado de sangre en la descompresión. Las arterias soportan presión observando el pulso manifiestamente.",
				recorrido:[
					{
						tipo:"din",
						mod:"V",
						x: 0.303,
						y: 0.206,
						iniImg:0,
						finImg:20,
					}
				],
				fondo:"cadera superior.jpg",
				escala: 0.79,
				giro: 3.1415,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/03",
			},
			{
				titulo: "4. ABORDAJE ANTERIOR. EJE LATERO MEDIAL. ARTICULACIÓN COXOFEMORAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 2_01.jpg","Cadera-Abordaje 2_02.jpg","Cadera-Abordaje 2_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con la cadera en posición anatómica. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar",
					opciones:["cadera superior posiciones 1.jpg","cadera superior posiciones 2.jpg","cadera superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda en la cara anterior de la coxofemoral movilizando la sonda cráneo caudalmente en eje corto sobre los vasos, cerca de la línea inguinal. Desde esta posición se moviliza la sonda hacia lateral y se corrige hacia caudal o craneal hasta que observamos línea hiperecóica de la cabeza femoral.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.434,y:0.294},
						fin:{x:0.394,y:0.211},
						iniImg:0,
						finImg:61,
						atlas:[{pos:4,atlas:"/cadera/atlas/cadera04_atlas01.svg"}],
					}
				],
				fondo:"cadera superior.jpg",
				escala: 0.79,
				giro: 3.1415,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/04",
			},
			{
				titulo: "5. ABORDAJE ANTERIOR. EJE CRÁNEO CAUDAL. ARTICULACIÓN COXOFEMORAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 2_01.jpg","Cadera-Abordaje 2_02.jpg","Cadera-Abordaje 2_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con la cadera en posición anatómica. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar.",
					opciones:["cadera superior posiciones 1.jpg","cadera superior posiciones 2.jpg","cadera superior posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda en la cara anterior de la coxofemoral movilizando la sonda cráneo caudalmente en eje corto sobre los vasos, cerca de la línea inguinal. Desde esta posición se moviliza la sonda hacia lateral y se corrige hacia caudal o craneal hasta que observamos línea hiperecóica de la cabeza femoral. Desde esta posición se gira a eje largo visualizando la cabeza femoral y la aparición del labrum coxal.",
				recorrido:[
					{
						tipo:"giro",
						x:279/700,
						y:140/700,
						ini:Math.PI,
						fin:3*Math.PI/2,
						iniImg:0,
						finImg:90,
						atlas:[{pos:84,atlas:"/cadera/atlas/cadera05_atlas01.svg"}],
					}
				],
				fondo:"cadera superior.jpg",
				escala: 0.79,
				giro: Math.PI,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/05",
			},
			{
				titulo: "6. ABORDAJE LATERAL. EJE CORTO. TRACTO ILIOTIBIAL, GLÚTEO MENOR Y GLÚTEO MEDIANO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 6_01.jpg","Cadera-Abordaje 6_02.jpg","Cadera-Abordaje 6_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la cadera a explorar visible y la contralateral apoyada. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["cadera superior lateral exterior posiciones 1.jpg","cadera superior lateral exterior posiciones 2.jpg","cadera superior lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el trocánter mayor haciendo un corte transversal latero-lateral.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.327,y:0.265},
						fin:{x:0.25,y:0.335},
						iniImg:0,
						finImg:70,
						atlas:[{pos:63,atlas:"/cadera/atlas/cadera06_atlas01.svg"}],
					}
				],
				fondo:"cadera superior lateral exterior.jpg",
				escala: 0.85,
				giro: 3.9725,
				ruido:"/ruido_840x700",
				ecografia:"/cadera/06",
			},
			{
				titulo: "7. ABORDAJE LATERAL. EJE CORTO. TRACTO ILIOTIBIAL, GLÚTEO MENOR Y GLÚTEO MEDIANO. TEST DINÁMICO: ROTACIÓN INTERNA DE CADERA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 6_01.jpg","Cadera-Abordaje 6_02.jpg","Cadera-Abordaje 6_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la cadera a explorar visible y la contralateral apoyada. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["cadera superior lateral exterior posiciones 1.jpg","cadera superior lateral exterior posiciones 2.jpg","cadera superior lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el trocánter mayor haciendo un corte transversal latero-lateral. Desde esta posición se le solicita al paciente que realiza rotación externa e interna de cadera sin mover la sonda.",
				recorrido:[
					{
						tipo:"din",
						x: 0.102,
						y: 0.248,
						iniImg:0,
						finImg:55,
						atlas:[{pos:1,atlas:"/cadera/atlas/cadera07_atlas01.svg"},{pos:50,atlas:"/cadera/atlas/cadera07_atlas02.svg"}],
					}
				],
				fondo:"/cadera_07",
				escala: 0.62,
				giro: 3.9379,
				ruido:"/ruido_1120x700",
				ecografia:"/cadera/07",
			},
			{
				titulo: "8. ABORDAJE LATERAL. EJE LARGO. TRACTO ILIOTIBIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 6_01.jpg","Cadera-Abordaje 6_02.jpg","Cadera-Abordaje 6_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la cadera a explorar visible y la contralateral apoyada. Se posiciona papel en el límite de la ropa interior del paciente para delimitar la zona a explorar. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["cadera superior lateral exterior posiciones 1.jpg","cadera superior lateral exterior posiciones 2.jpg","cadera superior lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el trocánter mayor haciendo un corte transversal latero-lateral. Desde esta posición se cambia a eje largo observando el tracto iliotibial y glúteo menor o mediano (según interés).",
				recorrido:[
					{
						tipo:"giro",
						x:0.318,
						y:0.274,
						ini:3.9430,
						fin:5.5138,
						iniImg:0,
						finImg:90,
						atlas:[{pos:88,atlas:"/cadera/atlas/cadera08_atlas01.svg"}],
					}
				],
				fondo:"cadera superior lateral exterior.jpg",
				escala: 0.85,
				giro: 3.9430,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/08",
			},
			{
				titulo: "9. ABORDAJE POSTERIOR. EJE CORTO. SEMITENDINOSO Y SEMIMEMBRANOSO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 9_01.jpg","Cadera-Abordaje 9_02.jpg","Cadera-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con los brazos apoyados en los costados y tobillos sobre una almohada.",
					opciones:["cadera trasera posiciones 1.jpg","cadera trasera posiciones 2.jpg","cadera trasera posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el isquion en eje corto sobre tendón común de isquiotibiales. Se debe comprimir el tejido para poder observar el isquion. Desde aquí deslizamos hacia caudal siguiendo la línea del semimembranoso y semitendinoso.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.362,y:0.671},
						fin:{x:0.681,y:0.621},
						iniImg:0,
						finImg:224,
						atlas:[{pos:28,atlas:"/cadera/atlas/cadera09_atlas01.svg"},{pos:185,atlas:"/cadera/atlas/cadera09_atlas02.svg"}],
					}
				],
				fondo:"cadera trasera.jpg",
				escala: 0.78,
				giro: 355/180*Math.PI,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/09",
			},
			{
				titulo: "10. ABORDAJE POSTERIOR. EJE LARGO. RAFE DEL SEMIMEMBRANOSO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 9_01.jpg","Cadera-Abordaje 9_02.jpg","Cadera-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con los brazos apoyados en los costados y tobillos sobre una almohada.",
					opciones:["cadera trasera posiciones 1.jpg","cadera trasera posiciones 2.jpg","cadera trasera posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el isquion en eje corto sobre tendón común de isquiotibiales. Se debe comprimir el tejido para poder observar el isquion. Desde aquí deslizamos hacia caudal siguiendo la línea del semimembranoso y semitendinoso. A la altura del tercio proximal y tercio medio se cambia de eje corto a eje largo sobre el semimembranoso.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.362,y:0.671},
						fin:{x:0.681,y:0.621},
						iniImg:0,
						finImg:187,
					},
					{
						tipo:"giro",
						mod: "inv",
						x:0.681,
						y:0.621,
						ini:6.2035,
						fin:4.6328,
						iniImg:188,
						finImg:314,
						atlas:[{pos:312,atlas:"/cadera/atlas/cadera10_atlas01.svg"}],
					}
				],
				fondo:"cadera trasera.jpg",
				escala: 0.78,
				giro: 6.2035,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/10",
			},
			{
				titulo: "11. ABORDAJE POSTERIOR. EJE CORTO. BÍCEPS FEMORAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Cadera-Abordaje 9_01.jpg","Cadera-Abordaje 9_02.jpg","Cadera-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con los brazos apoyados en los costados y tobillos sobre una almohada.",
					opciones:["cadera trasera posiciones 1.jpg","cadera trasera posiciones 2.jpg","cadera trasera posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el isquion en eje corto sobre tendón común de isquiotibiales. Se debe comprimir el tejido para poder observar el isquion. Desde aquí deslizamos hacia caudal siguiendo la línea del semimembranoso y semitendinoso. A la altura del tercio medio deslizamos hacia lateral en eje corto sobre las estructuras observando el nervio ciático y cabezas corta y larga del bíceps.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.362,y:0.611},
						fin:{x:0.385,y:0.77},
						iniImg:0,
						finImg:111,
						atlas:[{pos:77,atlas:"/cadera/atlas/cadera11_atlas01.svg"}],
					},
					{
						tipo:"mov",
						ini:{x:0.385,y:0.77},
						fin:{x:0.131,y:0.761},
						iniImg:112,
						finImg:259,
					}
				],
				fondo:"cadera trasera pierna.jpg",
				escala: 0.77,
				giro: 6.1568,
				ruido:"/ruido_700x700",
				ecografia:"/cadera/11",
			}
		] 
	},
	{
		titulo:"MMII RODILLA",
		abordajes:[
			{
				titulo: "1. ABORDAJE ANTERIOR. EJE LARGO. TENDÓN CUADRICIPITAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 1_01.jpg","Rodilla-Abordaje 1_02.jpg","Rodilla-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación sobre la camilla con los pies colgando.",
					opciones:["rodilla superior flexion posiciones 1.jpg","rodilla superior flexion posiciones 2.jpg","rodilla superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la rótula y tendón cuadricipital en eje largo sobre este último.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.457,y:0.545},
						fin:{x:0.541,y:0.545},
						iniImg:0,
						finImg:60,
						atlas:[{pos:34,atlas:"/rodilla/atlas/rodilla01_atlas01.svg"}],
					}
				],
				fondo:"rodilla superior flexion.jpg",
				escala: 0.97,
				giro: 0,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/01",
			},
			{
				titulo: "2. ABORDAJE ANTERIOR. EJE CORTO. REGIÓN INTERCONDÍLEA, CÓNDILOS Y CARTÍLAGO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 1_01.jpg","Rodilla-Abordaje 1_02.jpg","Rodilla-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación sobre la camilla con los pies colgando.",
					opciones:["rodilla superior flexion posiciones 1.jpg","rodilla superior flexion posiciones 2.jpg","rodilla superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre el tendón rotuliano en eje corto cerca de la rótula.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.482,y:0.472},
						fin:{x:0.482,y:0.558},
						iniImg:0,
						finImg:60,
						atlas:[{pos:43,atlas:"/rodilla/atlas/rodilla02_atlas01.svg"}],
					}
				],
				fondo:"rodilla superior flexion.jpg",
				escala: 0.97,
				giro: 4.7123,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/02",
			},
			{
				titulo: "3. ABORDAJE ANTERIOR. EJE LARGO. REGIÓN SUPRARROTULIANA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 1_01.jpg","Rodilla-Abordaje 1_02.jpg","Rodilla-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación sobre la camilla con los pies colgando.",
					opciones:["rodilla superior flexion posiciones 1.jpg","rodilla superior flexion posiciones 2.jpg","rodilla superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la rótula en eje largo sobre las fibras de inserción directa del recto anterior del cuádriceps.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.487,y:0.515},
						fin:{x:0.487,y:0.632},
						iniImg:0,
						finImg:81,
						atlas:[{pos:22,atlas:"/rodilla/atlas/rodilla03_atlas01.svg"}],
					}
				],
				fondo:"rodilla superior flexion.jpg",
				escala: 0.97,
				giro: 0,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/03",
			},
			{
				titulo: "4. ABORDAJE ANTERIOR. EJE LARGO. REGIÓN INFRARROTULIANA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 1_01.jpg","Rodilla-Abordaje 1_02.jpg","Rodilla-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación sobre la camilla con los pies colgando.",
					opciones:["rodilla superior flexion posiciones 1.jpg","rodilla superior flexion posiciones 2.jpg","rodilla superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la tuberosidad anterior de la tibia y tendón rotuliano en eje largo sobre este último.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.417,y:0.442},
						fin:{x:0.414,y:0.657},
						iniImg:0,
						finImg:148,
						atlas:[{pos:7,atlas:"/rodilla/atlas/rodilla04_atlas01.svg"},{pos:118,atlas:"/rodilla/atlas/rodilla04_atlas02.svg"}],
					}
				],
				fondo:"rodilla frontal.jpg",
				escala: 1.22,
				giro: 0,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/04",
			},
			{
				titulo: "5. ABORDAJE ANTERIOR. EJE LARGO. TENDÓN CUADRICIPITAL. TEST DINÁMICO PARA BURSA PRERROTULIANA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 1_01.jpg","Rodilla-Abordaje 1_02.jpg","Rodilla-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En sedestación sobre la camilla con los pies colgando.",
					opciones:["rodilla superior flexion posiciones 1.jpg","rodilla superior flexion posiciones 2.jpg","rodilla superior flexion posiciones 3.jpg"],
					valida:2,
				},
				ejercicio: "Posiciona la sonda sobre la rótula y tendón cuadricipital en eje largo sobre este último.",
				recorrido:[
					{
						tipo:"din",
						x: 0.424,
						y: 0.391,
						iniImg:0,
						finImg:39,
						atlas:[{pos:5,atlas:"/rodilla/atlas/rodilla05_atlas01.svg"}],
					}
				],
				fondo:"/rodilla_05",
				escala: 0.65,
				giro: 6.2489,
				ruido:"/ruido_840x700",
				ecografia:"/rodilla/05",
			},
			{
				titulo: "6. ABORDAJE MEDIAL. EJE LARGO. LIGAMENTO LATERAL INTERNO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 6_01.jpg","Rodilla-Abordaje 6_02.jpg","Rodilla-Abordaje 6_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino en rotación externa de cadera y ligera abducción.",
					opciones:["rodilla lateral posiciones 1.jpg","rodilla lateral posiciones 2.jpg","rodilla lateral posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre interlínea articular de la rodilla en eje largo sobre el resalte del ligamento lateral interno.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.514,y:0.53},
						fin:{x:0.515,y:0.497},
						iniImg:0,
						finImg:24,
						atlas:[{pos:17,atlas:"/rodilla/atlas/rodilla06_atlas01.svg"}],
					}
				],
				fondo:"rodilla lateral.jpg",
				escala: 1.12,
				giro: 4.7123,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/06",
			},
			{
				titulo: "7. ABORDAJE MEDIAL. EJE LARGO. CAJÓN LATERAL MEDIAL. TEST DINÁMICO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 6_01.jpg","Rodilla-Abordaje 6_02.jpg","Rodilla-Abordaje 6_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino en rotación externa de cadera y ligera abducción.",
					opciones:["rodilla lateral posiciones 1.jpg","rodilla lateral posiciones 2.jpg","rodilla lateral posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre interlínea articular de la rodilla en eje largo sobre el resalte del ligamento lateral interno. Realiza bostezo o cajón lateral medial para provoca tensión en ligamento lateral interno.",
				recorrido:[
					{
						tipo:"din",
						x: 0.617,
						y: 0.498,
						iniImg:0,
						finImg:55,
						atlas:[{pos:15,atlas:"/rodilla/atlas/rodilla07_atlas01.svg"}],
					}
				],
				fondo:"/rodilla_07",
				escala: 0.54,
				giro: 4.7123,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/07",
			},
			{
				titulo: "8. ABORDAJE MEDIAL. EJE LARGO. PATA DE GANSO SUPERFICIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 8_01.jpg","Rodilla-Abordaje 8_02.jpg","Rodilla-Abordaje 8_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino en rotación externa de cadera y ligera abducción.",
					opciones:["rodilla lateral interior flexion posiciones 1.jpg","rodilla lateral interior flexion posiciones 2.jpg","rodilla lateral interior flexion posiciones 3.jpg"],
					valida:1,
				},
				ejercicio: "Posiciona la sonda sobre interlínea articular de la rodilla en eje largo sobre el resalte del ligamento lateral interno. Desde esta posición pivota la sonda hacia anterior y desliza a caudal a la región de la pata de ganso superficial en eje largo sobre esta.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:514/700,y:295/700},
						fin:{x:457/700,y:245/700},
						iniImg:0,
						finImg:73,
						atlas:[{pos:3,atlas:"/rodilla/atlas/rodilla08_atlas01.svg"}],
					}
				],
				fondo:"rodilla lateral interior flexion.jpg",
				escala: 1.24,
				giro: 4.6912,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/08",
			},
			{
				titulo: "9. ABORDAJE LATERAL. EJE LARGO. TRACTO ILIOTIBIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 9_01.jpg","Rodilla-Abordaje 9_02.jpg","Rodilla-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la rodilla a explorar visible y la contralateral apoyada. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["rodilla lateral exterior posiciones 1.jpg","rodilla lateral exterior posiciones 2.jpg","rodilla lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la línea de la cintilla iliotibial en eje largo con la referencia del tubérculo de Gerdy.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.564,y:0.567},
						fin:{x:0.552,y:0.595},
						iniImg:0,
						finImg:20,
					},
					{
						tipo:"mov",
						ini:{x:0.552,y:0.595},
						fin:{x:0.355,y:0.512},
						iniImg:20,
						finImg:169,
						atlas:[{pos:21,atlas:"/rodilla/atlas/rodilla09_atlas01.svg"}],
					}
				],
				fondo:"rodilla lateral exterior.jpg",
				escala: 0.98,
				giro: 5.0998,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/09",
			},
			{
				titulo: "10. ABORDAJE LATERAL. EJE LARGO. LIGAMENTO LATERAL EXTERNO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 9_01.jpg","Rodilla-Abordaje 9_02.jpg","Rodilla-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la rodilla a explorar visible y la contralateral apoyada. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["rodilla lateral exterior posiciones 1.jpg","rodilla lateral exterior posiciones 2.jpg","rodilla lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cabeza del peroné dirigida hacia el cóndilo lateral del fémur buscando el surco del poplíteo.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.358,y:0.541},
						fin:{x:0.58,y:0.485},
						iniImg:0,
						finImg:159,
						atlas:[{pos:2,atlas:"/rodilla/atlas/rodilla10_atlas01.svg"},{pos:148,atlas:"/rodilla/atlas/rodilla10_atlas02.svg"}],
					}
				],
				fondo:"rodilla lateral exterior.jpg",
				escala: 0.98,
				giro: 4.4500,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/10",
			},
			{
				titulo: "11. ABORDAJE LATERAL. EJE LARGO. CAJÓN LATERAL LATERAL. TEST DINÁMICO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 9_01.jpg","Rodilla-Abordaje 9_02.jpg","Rodilla-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la rodilla a explorar visible y la contralateral apoyada. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["rodilla lateral exterior posiciones 1.jpg","rodilla lateral exterior posiciones 2.jpg","rodilla lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cabeza del peroné dirigida hacia el cóndilo lateral del fémur buscando el surco del poplíteo. Desde esta posición se realiza un varo o cajón lateral observando el ligamento lateral externo.",
				recorrido:[
					{
						tipo:"din",
						x: 0.312,
						y: 0.311,
						iniImg:0,
						finImg:33,
						atlas:[{pos:7,atlas:"/rodilla/atlas/rodilla11_atlas01.svg"}],
					}
				],
				fondo:"/rodilla_11",
				escala: 0.74,
				giro: 4.7123,
				ruido:"/ruido_1120x700",
				ecografia:"/rodilla/11",
			},
			{
				titulo: "12. ABORDAJE LATERAL. EJE LARGO. TENDÓN DEL BÍCEPS FEMORAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 9_01.jpg","Rodilla-Abordaje 9_02.jpg","Rodilla-Abordaje 9_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito lateral con la rodilla a explorar visible y la contralateral apoyada. La extremidad apoyada se mantiene en ligera flexión de cadera y rodilla. La contralateral en extensión y ligera aducción.",
					opciones:["rodilla lateral exterior posiciones 1.jpg","rodilla lateral exterior posiciones 2.jpg","rodilla lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cabeza del peroné dirigida hacia craneal en eje largo sobre el tendón del bíceps.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.72285714285,y:0.41857142857},
						fin:{x:0.69428571428,y:0.56857142857},
						iniImg:0,
						finImg:109,
						atlas:[{pos:102,atlas:"/rodilla/atlas/rodilla12_atlas01.svg"}],
					}
				],
				fondo:"rodilla lateral exterior.jpg",
				escala: 0.98,
				giro: 1.77325452003,
				ruido:"/ruido_1000x700",
				ecografia:"/rodilla/12",
			},
			{
				titulo: "13. ABORDAJE POSTERIOR. EJE CORTO. CÓNDILOS Y REGIÓN INTERCONDÍLEA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 13_01.jpg","Rodilla-Abordaje 13_02.jpg","Rodilla-Abordaje 13_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con las rodillas en extensión y tobillos apoyados sobre una almohada.",
					opciones:["rodilla superior trasera posiciones 1.jpg","rodilla superior trasera posiciones 2.jpg","rodilla superior trasera posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cabeza parte craneal del rombo poplíteo en eje corto sobre isquiotibiales, deslizando sonda hasta caudal del rombo poplíteo.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.047,y:0.301},
						fin:{x:0.322,y:0.245},
						iniImg:0,
						finImg:197,
						atlas:[{pos:55,atlas:"/rodilla/atlas/rodilla13_atlas01.svg"}],
					}
				],
				fondo:"rodilla superior trasera.jpg",
				escala: 0.70,
				giro: 0,
				ruido:"/ruido_700x700",
				ecografia:"/rodilla/13",
			},
			{
				titulo: "14. ABORDAJE POSTERIOR. EJE LARGO. GASTROCNEMIOS MEDIAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 13_01.jpg","Rodilla-Abordaje 13_02.jpg","Rodilla-Abordaje 13_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con las rodillas en extensión y tobillos apoyados sobre una almohada.",
					opciones:["rodilla superior trasera posiciones 1.jpg","rodilla superior trasera posiciones 2.jpg","rodilla superior trasera posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cabeza parte craneal del rombo poplíteo en eje corto sobre isquiotibiales, deslizando sonda hasta caudal del rombo poplíteo. Desde esta posición y deslizando la sonda sobre gastrocnemio medial, se cambia a eje largo.",
				recorrido:[
					{
						tipo:"giro",
						mod:"lat inv",
						x:0.52571428571,
						y:0.28142857142,
						ini:3*Math.PI/2,
						fin:4.01425727959,
						iniImg:0,
						finImg:40,
						atlas:[{pos:39,atlas:"/rodilla/atlas/rodilla14_atlas01.svg"}],
					}
				],
				fondo:"rodilla superior trasera.jpg",
				escala: 0.70,
				giro: 3*Math.PI/2,
				ruido:"/ruido_1120x700",
				ecografia:"/rodilla/14",
			},
			{
				titulo: "15. ABORDAJE POSTERIOR. EJE LARGO. GASTROCNEMIOS LATERAL.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Rodilla-Abordaje 13_01.jpg","Rodilla-Abordaje 13_02.jpg","Rodilla-Abordaje 13_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con las rodillas en extensión y tobillos apoyados sobre una almohada.",
					opciones:["rodilla superior trasera posiciones 1.jpg","rodilla superior trasera posiciones 2.jpg","rodilla superior trasera posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cabeza parte craneal del rombo poplíteo en eje corto sobre isquiotibiales, deslizando sonda hasta caudal del rombo poplíteo. Desde esta posición y deslizando la sonda sobre gastrocnemio lateral, se cambia a eje largo.",
				recorrido:[
					{
						tipo:"giro",
						mod:"lat1",
						x:291/700,
						y:133/700,
						ini:270/180*Math.PI,
						fin:280/180*Math.PI,
						iniImg:0,
						finImg:19,
						atlas:[{pos:19,atlas:"/rodilla/atlas/rodilla15_atlas01.svg"}],
					}
				],
				fondo:"rodilla superior trasera.jpg",
				escala: 0.70,
				giro: 270/180*Math.PI,
				ruido:"/ruido_1120x700",
				ecografia:"/rodilla/15",
			}
		]
	},
	{
		titulo:"MMII TOBILLO-PIE",
		abordajes:[
			{
				titulo: "1. ABORDAJE POSTERIOR. EJE LARGO. REGIÓN RETROAQUILEA.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 1_01.jpg","Tobillo-pie-Abordaje 1_02.jpg","Tobillo-pie-Abordaje 1_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con las rodillas en extensión y tobillos apoyados sobre una almohada y los pies excedidos en los pies de la camilla para poder hacer dorsiflexión.",
					opciones:["tobillo-pie posterior dorsiflexion posiciones 1.jpg","tobillo-pie posterior dorsiflexion posiciones 2.jpg","tobillo-pie posterior dorsiflexion posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cara posterior del calcáneo en eje largo sobre el tendón de Aquiles.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.451,y:0.27},
						fin:{x:0.435,y:0.441},
						iniImg:0,
						finImg:121,
						atlas:[{pos:44,atlas:"/tobillo-pie/atlas/tobillo-pie01_atlas01.svg"}],
					}
				],
				fondo:"tobillo-pie posterior dorsiflexion.jpg",
				escala: 0.98,
				giro: 0,
				ruido:"/ruido_840x700",
				ecografia:"/tobillo-pie/01",
			},
			{
				titulo: "2. ABORDAJE CAUDAL. EJE CORTO. REGIÓN PLANTAR CABEZA DE LOS METATARSIANOS",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 2_01.jpg","Tobillo-pie-Abordaje 2_02.jpg","Tobillo-pie-Abordaje 2_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con las rodillas en extensión y tobillos apoyados sobre una almohada y los pies excedidos en los pies de la camilla para poder hacer dorsiflexión.",
					opciones:["tobillo-pie planta posiciones 1.jpg","tobillo-pie planta posiciones 2.jpg","tobillo-pie planta posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cara plantar de la cabeza de los metatarsianos en eje corto sobre los flexores de dedos.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.33,y:0.738571429},
						fin:{x:0.422857143,y:0.808571429},
						iniImg:0,
						finImg:17,
						atlas:[{pos:6,atlas:"/tobillo-pie/atlas/tobillo-pie02_atlas01.svg"},],
					},{
						tipo:"mov",
						ini:{x:0.422857143,y:0.808571429},
						fin:{x:0.477142857,y:0.814285714},
						iniImg:18,
						finImg:42,
						atlas:[{pos:29,atlas:"/tobillo-pie/atlas/tobillo-pie02_atlas02.svg"},],
					},{
						tipo:"mov",
						ini:{x:0.477142857,y:0.814285714},
						fin:{x:0.521428571,y:0.788571429},
						iniImg:43,
						finImg:69,
						atlas:[{pos:56,atlas:"/tobillo-pie/atlas/tobillo-pie02_atlas03.svg"},],
					},{
						tipo:"mov",
						ini:{x:0.521428571,y:0.788571429},
						fin:{x:0.548571429,y:0.758571429},
						iniImg:70,
						finImg:96,
						atlas:[{pos:84,atlas:"/tobillo-pie/atlas/tobillo-pie02_atlas04.svg"},],
					},{
						tipo:"mov",
						ini:{x:0.548571429,y:0.758571429},
						fin:{x:0.604285714,y:0.718571429},
						iniImg:97,
						finImg:120,
						atlas:[{pos:109,atlas:"/tobillo-pie/atlas/tobillo-pie02_atlas05.svg"}],
					}
				],
				fondo:"tobillo-pie planta.jpg",
				escala: 1.02,
				giro: 1.5708,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/02",
			},
			{
				titulo: "3. ABORDAJE LATERAL. EJE LARGO. LIGAMENTO PERONEOASTRAGALINO ANTERIOR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 3_01.jpg","Tobillo-pie-Abordaje 3_02.jpg","Tobillo-pie-Abordaje 3_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con las rodillas en extensión y los pies excedidos en los pies de la camilla para poder hacer movilizaciones.",
					opciones:["tobillo-pie lateral exterior posiciones 1.jpg","tobillo-pie lateral exterior posiciones 2.jpg","tobillo-pie lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el maléolo peroneal en dirección hacia la cabeza del 5º metatarsiano.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:294/700,y:409/700},
						fin:{x:324/700,y:327/700},
						iniImg:0,
						finImg:86,
						atlas:[{pos:65,atlas:"/tobillo-pie/atlas/tobillo-pie03_atlas01.svg"}],
					}
				],
				fondo:"tobillo-pie lateral exterior.jpg",
				escala: 1.26,
				giro: 111/180*Math.PI,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/03",
			},
			{
				titulo: "4. ABORDAJE LATERAL. EJE LARGO. LIGAMENTO PERONEO CALCÁNEO MEDIO Y TEST DINÁMICO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 3_01.jpg","Tobillo-pie-Abordaje 3_02.jpg","Tobillo-pie-Abordaje 3_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con las rodillas en extensión y los pies excedidos en los pies de la camilla para poder hacer movilizaciones.",
					opciones:["tobillo-pie lateral exterior posiciones 1.jpg","tobillo-pie lateral exterior posiciones 2.jpg","tobillo-pie lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el maléolo peroneal en dirección hacia la cabeza del 5º metatarsiano. Desde esta posición sin perder el maléolo se pivota la sonda hacia caudal en eje largo sobre el ligamento peroneo-calcaneo medio. Se realiza maniobra de inversión forzada para testar el ligamento.",
				recorrido:[
					{
						tipo:"din",
						x: 0.547,
						y: 0.781,
						iniImg:0,
						finImg:35,
						atlas:[{pos:34,atlas:"/tobillo-pie/atlas/tobillo-pie04_atlas01.svg"}],
					}
				],
				fondo:"/tobillo-pie_04",
				escala: 1.27,
				giro: 1.5332,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/04",
			},
			{
				titulo: "5. ABORDAJE LATERAL. EJE CORTO. RETINÁCULO DE LOS EVERSORES.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 3_01.jpg","Tobillo-pie-Abordaje 3_02.jpg","Tobillo-pie-Abordaje 3_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con las rodillas en extensión y los pies excedidos en los pies de la camilla para poder hacer movilizaciones.",
					opciones:["tobillo-pie lateral exterior posiciones 1.jpg","tobillo-pie lateral exterior posiciones 2.jpg","tobillo-pie lateral exterior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el maléolo peroneal en dirección hacia posterior. Desde esta posición se desliza la sonda hacia caudal para ver la disposición de los tendones de los peroneos lateral largo y corto.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:368/700,y:550/700},
						fin:{x:306/700,y:442/700},
						iniImg:0,
						finImg:125,
						atlas:[{pos:1,atlas:"/tobillo-pie/atlas/tobillo-pie05_atlas01.svg"},{pos:106,atlas:"/tobillo-pie/atlas/tobillo-pie05_atlas02.svg"}],
					}
				],
				fondo:"tobillo-pie lateral exterior.jpg",
				escala: 1.26,
				giro: 1.1259,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/05",
			},
			{
				titulo: "6. ABORDAJE CAUDAL. EJE LARGO. FASCIA PLANTAR.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 6_01.jpg","Tobillo-pie-Abordaje 6_02.jpg","Tobillo-pie-Abordaje 6_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito prono con las rodillas en extensión y tobillos apoyados sobre una almohada y los pies excedidos en los pies de la camilla para poder hacer dorsiflexión.",
					opciones:["tobillo-pie planta posiciones 1.jpg","tobillo-pie planta posiciones 2.jpg","tobillo-pie planta posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre la cara plantar del calcáneo en eje largo sobre la fascia plantar.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.424,y:0.211},
						fin:{x:0.394,y:0.494},
						iniImg:0,
						finImg:197,
						atlas:[{pos:4,atlas:"/tobillo-pie/atlas/tobillo-pie06_atlas01.svg"},{pos:150,atlas:"/tobillo-pie/atlas/tobillo-pie06_atlas02.svg"}],
					}
				],
				fondo:"tobillo-pie planta.jpg",
				escala: 1.02,
				giro: 0,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/06",
			},
			{
				titulo: "7. ABORDAJE MEDIAL. EJE CORTO. RETINÁCULO DE LOS FLEXORES.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 7_01.jpg","Tobillo-pie-Abordaje 7_02.jpg","Tobillo-pie-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con las rodillas en extensión y los pies excedidos en los pies de la camilla para poder hacer movilizaciones.",
					opciones:["tobillo-pie lateral interior posiciones 1.jpg","tobillo-pie lateral interior posiciones 2.jpg","tobillo-pie lateral interior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el maléolo tibial en dirección hacia posterior. Desde esta posición se desliza la sonda hacia caudal para ver la disposición de los tendones de los inversores y paquete vasculo-nervioso.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:0.341,y:0.765},
						fin:{x:0.298,y:0.655},
						iniImg:0,
						finImg:84,
						atlas:[{pos:46,atlas:"/tobillo-pie/atlas/tobillo-pie07_atlas01.svg"}],
					}
				],
				fondo:"tobillo-pie lateral interior.jpg",
				escala: 1.09,
				giro: 1.2144,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/07",
			},
			{
				titulo: "8. ABORDAJE MEDIAL. EJE LARGO. LIGAMENTO TIBIO CALCÁNEO MEDIO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 7_01.jpg","Tobillo-pie-Abordaje 7_02.jpg","Tobillo-pie-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con las rodillas en extensión y los pies excedidos en los pies de la camilla para poder hacer movilizaciones.",
					opciones:["tobillo-pie lateral interior posiciones 1.jpg","tobillo-pie lateral interior posiciones 2.jpg","tobillo-pie lateral interior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el maléolo tibial en dirección hacia caudal en eje largo sobre el ligamento tibio-calcáneo medio.",
				recorrido:[
					{
						tipo:"mov",
						ini:{x:226/700,y:515/700},
						fin:{x:234/700,y:482/700},
						iniImg:0,
						finImg:33,
						atlas:[{pos:3,atlas:"/tobillo-pie/atlas/tobillo-pie08_atlas01.svg"}],
					}
				],
				fondo:"tobillo-pie lateral interior.jpg",
				escala: 1.09,
				giro: 1.8760,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/08",
			},
			{
				titulo: "9. ABORDAJE MEDIAL. EJE LARGO. TIBIOASTRAGALINO ANTERIOR. TEST DINÁMICO.",
				situar:{
					titulo:"Junto al ecógrafo y paciente con la mano izquierda sobre el teclado del ecógrafo y la derecha sosteniendo la sonda contra la región a explorar, para diestros, para zurdos al contrario.",
					opciones:["Tobillo-pie-Abordaje 7_01.jpg","Tobillo-pie-Abordaje 7_02.jpg","Tobillo-pie-Abordaje 7_03.jpg"],
					valida:0,
				},
				anatomia:{
					titulo:"En decúbito supino con las rodillas en extensión y los pies excedidos en los pies de la camilla para poder hacer movilizaciones.",
					opciones:["tobillo-pie lateral interior posiciones 1.jpg","tobillo-pie lateral interior posiciones 2.jpg","tobillo-pie lateral interior posiciones 3.jpg"],
					valida:0,
				},
				ejercicio: "Posiciona la sonda sobre el maléolo tibial en dirección anterior en eje largo sobre el ligamento tibio-astragalino anterior. Se realiza maniobra de eversión con pronación para tensarlo.",
				recorrido:[
					{
						tipo:"din",
						x: 0.494,
						y: 0.6,
						iniImg:0,
						finImg:34,
						atlas:[{pos:5,atlas:"/tobillo-pie/atlas/tobillo-pie09_atlas01.svg"}],
					}
				],
				fondo:"/tobillo-pie_09",
				escala: 1.24,
				giro: 2.3282,
				ruido:"/ruido_1120x700",
				ecografia:"/tobillo-pie/09",
			}
		] 
		
	},
];

var estructurasTxt = [];
estructurasTxt["tejidoadiposo"] = "TEJIDO ADIPOSO";
estructurasTxt["clavicula"] = "CLAVÍCULA";
estructurasTxt["musculopsoas"] = "MÚSCULO PSOAS";
estructurasTxt["acetabulodelcoxal"] = "ACETÁBULO DEL COXAL";
estructurasTxt["musculorectoanteriorcuadriceps"] = "MÚSCULO RECTO ANTERIOR CUÁDRICEPS";
estructurasTxt["ligamentosiliofemoralesycapsulaarticular"] = "LIGAMENTOS ILIOFEMORALES Y CÁPSULA ARTICULAR";
estructurasTxt["ligamentosiliofemorales"] = "LIGAMENTOS ILIOFEMORALES";
estructurasTxt["cabezadelfemur"] = "CABEZA DEL FÉMUR";
estructurasTxt["piel"] = "PIEL";
estructurasTxt["tendondelmusculorectofemoral"] = "TENDÓN DEL MÚSCULO RECTO FEMORAL";
estructurasTxt["musculosartorio"] = "MÚSCULO SARTORIO";
estructurasTxt["musculopsoas-iliaco"] = "MÚSCULO PSOAS-ILIACO";
estructurasTxt["cabezalargadelmusculobicepsfemoral"] = "CABEZA LARGA DEL MÚSCULO BÍCEPS FEMORAL";
estructurasTxt["cabezacortadelmusculobicepsfemoral"] = "CABEZA CORTA DEL MÚSCULO BÍCEPS FEMORAL";
estructurasTxt["musculoaductorlargo"] = "MÚSCULO ADUCTOR LARGO";
estructurasTxt["musculoaductormenor"] = "MÚSCULO ADUCTOR MENOR";
estructurasTxt["musculoaductormayor"] = "MÚSCULO ADUCTOR MAYOR";
estructurasTxt["musculogracil"] = "MÚSCULO GRÁCIL";
estructurasTxt["septodelmusculoaductorlargo"] = "SEPTO DEL MÚSCULO ADUCTOR LARGO";
estructurasTxt["rafedelsemitendinoso"] = "RAFE DEL SEMITENDINOSO";
estructurasTxt["tendondelsemimembranoso"] = "TENDÓN DEL SEMIMEMBRANOSO";
estructurasTxt["semitendinoso"] = "SEMITENDINOSO";
estructurasTxt["musculosemitendinoso"] = "MÚSCULO SEMITENDINOSO";
estructurasTxt["musculosemimembranoso"] = "MÚSCULO SEMIMEMBRANOSO";
estructurasTxt["musculogluteomayor"] = "MÚSCULO GLÚTEO MAYOR";
estructurasTxt["insercionisquiotibiales"] = "INSERCIÓN ISQUIOTIBIALES";
estructurasTxt["isquion"] = "ISQUION";
estructurasTxt["tractoiliotibial"] = "TRACTO ILIOTIBIAL";
estructurasTxt["musculovastoexterno"] = "MÚSCULO VASTO EXTERNO";
estructurasTxt["bursapertrocanterea"] = "BURSA PERTROCANTEREA";
estructurasTxt["femurtrocantermayor"] = "FÉMUR TROCÁNTER MAYOR";
estructurasTxt["musculotensorfascialata"] = "MÚSCULO TENSOR DE LA FASCIA LATA";
estructurasTxt["gluteomenor"] = "GLÚTEO MENOR";
estructurasTxt["trocantermayordelfemur"] = "TROCÁNTER MAYOR DEL FÉMUR";
estructurasTxt["musculopectineo"] = "MÚSCULO PECTÍNEO";
estructurasTxt["fasciacrural"] = "FASCIA CRURAL";
estructurasTxt["arteriafemoralcomun"] = "ARTERIA FEMORAL COMÚN";
estructurasTxt["venasafenamayor"] = "VENA SAFENA MAYOR";
estructurasTxt["venafemoral"] = "VENA FEMORAL";
estructurasTxt["tendondelgluteomediano"] = "TENDÓN DEL GLÚTEO MEDIANO";
estructurasTxt["tendondelgluteomenor"] = "TENDÓN DEL GLÚTEO MENOR";
estructurasTxt["bursas"] = "BURSAS";
estructurasTxt["retinaculodorsaldelcarpo"] = "RETINÁCULO DORSAL DEL CARPO";
estructurasTxt["cuartocompartimento-extensorcomundelosdedos-extensorpropiodelsegundodedo"] = "CUARTO COMPARTIMENTO -EXTENSOR COMÚN DE LOS DEDOS -EXTENSOR PROPIO DEL SEGUNDO DEDO";
estructurasTxt["radio"] = "HUESO RADIO";
estructurasTxt["cubito"] = "HUESO CÚBITO";
estructurasTxt["retinaculoanterior"] = "RETINÁCULO ANTERIOR";
estructurasTxt["flexorescomunprofundoysuperficialdelosdedos"] = "FLEXORES COMÚN PROFUNDO Y SUPERFICIAL DE LOS DEDOS";
estructurasTxt["flexorlargodelpulgar"] = "FLEXOR LARGO DEL PULGAR";
estructurasTxt["nerviomediano"] = "NERVIO MEDIANO";
estructurasTxt["huesoescafoides"] = "HUESO ESCAFOIDES";
estructurasTxt["huesosemilunar"] = "HUESO SEMILUNAR";
estructurasTxt["huesopisiforme"] = "HUESO PISIFORME";
estructurasTxt["nerviocubital"] = "NERVIO CUBITAL";
estructurasTxt["arteriacubital"] = "ARTERIA CUBITAL";
estructurasTxt["canaldeguyon"] = "CANAL DE GUYÓN";
estructurasTxt["piramidal"] = "HUESO PIRAMIDAL";
estructurasTxt["flexorcomundelosdedos"] = "FLEXOR COMÚN DE LOS DEDOS";
estructurasTxt["grande"] = "HUESO GRANDE";
estructurasTxt["tendondelmusculoabductorlargodelpulgar"] = "TENDÓN DEL MÚSCULO ABDUCTOR LARGO DEL PULGAR";
estructurasTxt["tendondelmusculoextensorcortodelpulgar"] = "TENDÓN DEL MÚSCULO EXTENSOR CORTO DEL PULGAR";
estructurasTxt["tendondelmusculoextensorlargodelpulgar"] = "TENDÓN DEL MÚSCULO EXTENSOR LARGO DEL PULGAR";
estructurasTxt["tendondelextensorpropiodelquintodedo"] = "TENDÓN DEL EXTENSOR PROPIO DEL QUINTO DEDO";
estructurasTxt["vainadelsegundoradial"] = "VAINA DEL SEGUNDO RADIAL";
estructurasTxt["vainadelprimerradial"] = "VAINA DEL PRIMER RADIAL";
estructurasTxt["tendondelmusculoextensorradialcortoosegundoradial"] = "TENDÓN DEL MÚSCULO EXTENSOR RADIAL CORTO O SEGUNDO RADIAL";
estructurasTxt["tendondelmusculoextensorradiallargooprimerradial"] = "TENDÓN DEL MÚSCULO EXTENSOR RADIAL LARGO O PRIMER RADIAL";
estructurasTxt["retinaculo"] = "RETINÁCULO";
estructurasTxt["vainadelmusculoextensorcubital"] = "VAINA DEL MÚSCULO EXTENSOR CUBITAL";
estructurasTxt["tendondelmusculoextensorcubital"] = "TENDÓN DEL MÚSCULO EXTENSOR CUBITAL";
estructurasTxt["tuberculodelister"] = "TUBÉRCULO DE LISTER";
estructurasTxt["cuartocompartimento"] = "CUARTO COMPARTIMENTO";
estructurasTxt["tercercompartimento"] = "TERCER COMPARTIMENTO";
estructurasTxt["segundocompartimento"] = "SEGUNDO COMPARTIMENTO"; 
estructurasTxt["tendondelosmusculosepitrocleares"] = "TENDÓN DE LOS MÚSCULOS EPITROCLEARES"; 
estructurasTxt["musculosepitrocleares"] = "MÚSCULOS EPITROCLEARES"; 
estructurasTxt["humero-epitroclea"] = "HÚMERO-EPITROCLEA"; 
estructurasTxt["humero-troclea"] = "HÚMERO-TRÓCLEA"; 
estructurasTxt["tendonepicondileos"] = "TENDÓN EPICONDILEOS"; 
estructurasTxt["humeroepicondilo"] = "HÚMERO EPICÓNDILO"; 
estructurasTxt["radiocabezaradial"] = "RADIO CABEZA RADIAL"; 
estructurasTxt["ligamentocolateralmedial"] = "LIGAMENTO COLATERAL MEDIAL"; 
estructurasTxt["nerviocubital"] = "NERVIO CUBITAL"; 
estructurasTxt["cubito-olecranon"] = "CÚBITO-OLÉCRANON"; 
estructurasTxt["musculotriceps"] = "MÚSCULO TRÍCEPS"; 
estructurasTxt["musculobraquialanterior"] = "MÚSCULO BRAQUIAL ANTERIOR"; 
estructurasTxt["nervioradial"] = "NERVIO RADIAL"; 
estructurasTxt["humero"] = "HUESO HÚMERO"; 
estructurasTxt["regiontrocleardelhumero"] = "REGIÓN TROCLEAR DEL HÚMERO"; 
estructurasTxt["regioncondilardelhumero"] = "REGIÓN CONDILAR DEL HÚMERO"; 
estructurasTxt["sinovialarticular"] = "SINOVIAL ARTICULAR"; 
estructurasTxt["recesoanterior"] = "RECESO ANTERIOR"; 
estructurasTxt["recesoposterior"] = "RECESO POSTERIOR"; 
estructurasTxt["musculobraquiorradial"] = "MÚSCULO BRAQUIORRADIAL"; 
estructurasTxt["ramaposteriormotora"] = "RAMA POSTERIOR MOTORA"; 
estructurasTxt["ramaanteriorsensitiva"] = "RAMA ANTERIOR SENSITIVA"; 
estructurasTxt["pronadorredondo"] = "PRONADOR REDONDO"; 
estructurasTxt["flexorcomunsuperficialdelosdedos"] = "FLEXOR COMÚN SUPERFICIAL DE LOS DEDOS"; 
estructurasTxt["flexorcomunprofundodelosdedos"] = "FLEXOR COMÚN PROFUNDO DE LOS DEDOS"; 
estructurasTxt["nerviomediano"] = "NERVIO MEDIANO"; 
estructurasTxt["humero-fosaolecraniana"] = "HÚMERO-FOSA OLECRANIANA"; 
estructurasTxt["tendondeltriceps"] = "TENDÓN DEL TRÍCEPS"; 
estructurasTxt["tendonbicepsbraquial"] = "TENDÓN BÍCEPS BRAQUIAL"; 
estructurasTxt["venabraquialsuperficial"] = "VENA BRAQUIAL SUPERFICIAL"; 
estructurasTxt["arteriabraquialsuperficial"] = "ARTERIA BRAQUIAL SUPERFICIAL"; 
estructurasTxt["musculosupinador"] = "MÚSCULO SUPINADOR"; 
estructurasTxt["capsulaarticularyligamentos"] = "CÁPSULA ARTICULAR Y LIGAMENTOS"; 
estructurasTxt["capsulaarticular"] = "CÁPSULA ARTICULAR"; 
estructurasTxt["cartilagoarticularysinovial"] = "CARTÍLAGO ARTICULAR Y SINOVIAL"; 
estructurasTxt["nervioradialramaanteriorsensitiva"] = "NERVIO RADIAL RAMA ANTERIOR SENSITIVA";
estructurasTxt["nervioradialramaposteriormotriz"] = "NERVIO RADIAL RAMA POSTERIOR MOTRÍZ"; 
estructurasTxt["arcadadefrohse"] = "ARCADA DE FROHSE";
estructurasTxt["cartilagoycapsulasinovial"] = "CARTÍLAGO Y CÁPSULA SINOVIAL "; 
estructurasTxt["condilohumeral"] = "CÓNDILO HUMERAL"; 
estructurasTxt["fosaradial"] = "FOSA RADIAL";
estructurasTxt["humero-correderabicipital"] = "CORREDERA BICIPITAL DEL HÚMERO";
estructurasTxt["deltoides"] = "MÚSCULO DELTOIDES";
estructurasTxt["tendonlargodelbiceps"] = "TENDÓN LARGO DEL BÍCEPS";
estructurasTxt["correderabicipital"] = "CORREDERA BICIPITAL";
estructurasTxt["troquiter"] = "TROQUÍTER";
estructurasTxt["troquin"] = "TROQUÍN";
estructurasTxt["tendonpectoralmayor"] = "TENDÓN DEL PECTORAL MAYOR";
estructurasTxt["infraespinoso"] = "MÚSCULO INFRAESPINOSO";
estructurasTxt["tendoninfraespinoso"] = "TENDÓN INFRAESPINOSO";
estructurasTxt["troquiter-humero"] = "TROQUÍTER HÚMERO";
estructurasTxt["tendonmusculosupraespinoso"] = "TENDÓN DEL MÚSCULO SUPRAESPINOSO";
estructurasTxt["tendondelmusculoredondomenor"] = "TENDÓN DEL MÚSCULO REDONDO MENOR";
estructurasTxt["escapula"] = "ESCÁPULA";
estructurasTxt["musculoredondomenor"] = "MÚSCULO REDONDO MENOR";
estructurasTxt["tendondelmusculoinfraespinoso"] = "TENDÓN DEL MÚSCULO INFRAESPINOSO";
estructurasTxt["rodetefibrocartilago"] = "RODETE FIBROCARTÍLAGO";
estructurasTxt["cabezahumeral"] = "CABEZA HUMERAL";
estructurasTxt["apofisiscoracoides"] = "APÓFISIS CORACOIDES";
estructurasTxt["inserciondelcoracobraquialycabezacortabiceps"] = "INSERCIÓN DEL CORACOBRAQUIAL Y CABEZA CORTA DEL BÍCEPS";
estructurasTxt["tendondelsubescapular"] = "TENDÓN DEL SUBESCAPULAR";
estructurasTxt["glenoidesecapular"] = "GLENOIDES ECAPULAR";
estructurasTxt["espinadelaescapula"] = "ESPINA DE LA ESCÁPULA";
estructurasTxt["fosainfraespinosa"] = "FOSA INFRAESPINOSA";
estructurasTxt["regionaxilardelaescapula"] = "REGIÓN AXILAR DE LA ESCÁPULA";
estructurasTxt["arteriaaxilar"] = "ARTERIA AXILAR";
estructurasTxt["bordeaxilardelaescapula"] = "BORDE AXILAR DE LA ESCÁPULA";
estructurasTxt["coracobraquial"] = "MÚSCULO CORACOBRAQUIAL";
estructurasTxt["nerviomusculocutaneo"] = "NERVIO MUSCULOCUTÁNEO";
estructurasTxt["acromion"] = "HUESO ACROMION";
estructurasTxt["musculopectoralmayor"] = "MÚSCULO DEL PECTORAL MAYOR";
estructurasTxt["musculocabezacortadelbiceps"] = "MÚSCULO CABEZA CORTA DEL BÍCEPS";
estructurasTxt["articulacionaxilar"] = "ARTICULACIÓN AXILAR";
estructurasTxt["ligamentocolateralmedialfasciculosuperficial"] = "LIGAMENTO COLATERAL MEDIAL FASCÍCULO SUPERFICIAL";
estructurasTxt["ligamentocolateralmedialfasciculoprofundofemoro-meniscal"] = "LIGAMENTO COLATERAL MEDIAL FASCÍCULO PROFUNDO FEMORO-MENISCAL";
estructurasTxt["ligamentocolateralmedialfasciculoprofundotibio-meniscal"] = "LIGAMENTO COLATERAL MEDIAL FASCÍCULO PROFUNDO TIBIO-MENISCAL";
estructurasTxt["tibia"] = "TIBIA";
estructurasTxt["femur"] = "FÉMUR";
estructurasTxt["meniscomedial"] = "MENISCO MEDIAL";
estructurasTxt["recesoposteriorarticular"] = "RECESO POSTERIOR ARTICULAR";
estructurasTxt["condilofemoral"] = "CÓNDILO FEMORAL";
estructurasTxt["condilofemoralexterno"] = "CÓNDILO FEMORAL EXTERNO";
estructurasTxt["cartilagoarticular"] = "CARTÍLAGO ARTICULAR";
estructurasTxt["musculosisquiotibiales"] = "MÚSCULOS ISQUIOTIBIALES";
estructurasTxt["musculogastrocnemiolateral"] = "MÚSCULO GASTROCNEMIO LATERAL";
estructurasTxt["nerviociaticopopliteointerno"] = "NERVIO CIÁTICO POPLITEO INTERNO";
estructurasTxt["musculogastrocnemiomedial"] = "MÚSCULO GASTROCNEMIO MEDIAL";
estructurasTxt["arteriapoplitea"] = "ARTERIA POPLÍTEA";
estructurasTxt["femurcondilo"] = "FÉMUR CÓNDILO";
estructurasTxt["surcodelpopliteo"] = "SURCO DEL POPLÍTEO";
estructurasTxt["cabezadelperone"] = "CABEZA DEL PERONÉ";
estructurasTxt["ligamentocolateralexterno"] = "LIGAMENTO COLATERAL EXTERNO";
estructurasTxt["ligamentolateralexterno"] = "LIGAMENTO LATERAL EXTERNO";
estructurasTxt["tendondelmusculopopliteo"] = "TENDÓN DEL MÚSCULO POPLÍTEO";
estructurasTxt["ligamentolateralinferiorfasciculoprofundofemoro-meniscal"] = "LIGAMENTO LATERAL INFERIOR FASCÍCULO PROFUNDO FEMORO-MENISCAL";
estructurasTxt["ligamentolateralinferiorfasciculoprofundotibio-meniscal"] = "LIGAMENTO LATERAL INFERIOR FASCÍCULO PROFUNDO TIBIO-MENISCAL";
estructurasTxt["ligamentolateralinferiorsuperficial"] = "LIGAMENTO LATERAL INFERIOR SUPERFICIAL";
estructurasTxt["patadegansosuperficial"] = "PATA DE GANSO SUPERFICIAL";
estructurasTxt["vasossanguineos"] = "VASOS SANGUÍNEOS";
estructurasTxt["femur-condilomedial"] = "FÉMUR-CONDILO MEDIAL";
estructurasTxt["femur-regionintercondilea"] = "FÉMUR-REGIÓN INTERCONDÍLEA";
estructurasTxt["femur-condilolateral"] = "FÉMUR-CONDILO LATERAL";
estructurasTxt["musculovastomedial"] = "MÚSCULO VASTO MEDIAL";
estructurasTxt["tendoncuadricipital"] = "TENDÓN CUADRICIPITAL";
estructurasTxt["rotula"] = "RÓTULA";
estructurasTxt["tejidoadiposoperirrotuliano"] = "TEJIDO ADIPOSO PERIRROTULIANO";
estructurasTxt["bursaprerrotuliana"] = "BURSA PRERROTULIANA";
estructurasTxt["tendonbicepsfemoral"] = "TENDÓN BÍCEPS FEMORAL";
estructurasTxt["musculocabezacortadelbiceps"] = "MÚSCULO CABEZA CORTA DEL BÍCEPS";
estructurasTxt["peronecabeza"] = "CABEZA DE PERONÉ";
estructurasTxt["tibia-tuberculodejerdy"] = "TIBIA-TUBÉRCULO DE GERDY";
estructurasTxt["bursa"] = "BURSA";
estructurasTxt["musculosoleo"] = "MÚSCULO SÓLEO";
estructurasTxt["unionmiotendinosa"] = "UNIÓN MIOTENDINOSA";
estructurasTxt["fasciaprofundadelmusculosoleo"] = "FASCIA PROFUNDA DEL MÚSCULO SÓLEO";
estructurasTxt["tendonrotuliano"] = "TENDÓN ROTULIANO";
estructurasTxt["grasadehoffa"] = "GRASA DE HOFFA";
estructurasTxt["tuberosidadanteriordelatibia"] = "TUBEROSIDAD ANTERIOR DE LA TIBIA";
estructurasTxt["bursainfrarotuliana"] = "BURSA INFRAROTULIANA";
estructurasTxt["tendondirectodelrectoanteror"] = "TENDÓN DIRECTO DEL RECTO ANTEROR DEL CRUÁDRICEPS";
estructurasTxt["tejidosubcutaneo"] = "TEJIDO SUBCUTÁNEO";
estructurasTxt["gel"] = "GEL"; 
estructurasTxt["calcaneo"] = "CALCÁNEO"; 
estructurasTxt["tejidoadiposoplantar"] = "TEJIDO ADIPOSO PLANTAR"; 
estructurasTxt["fasciaplantar"] = "FASCIA PLANTAR"; 
estructurasTxt["musculoflexorcortodelosdedos"] = "MÚSCULO FLEXOR CORTO DE LOS DEDOS"; 
estructurasTxt["musculocuadradoplantar"] = "MÚSCULO CUADRADO PLANTAR"; 
estructurasTxt["tendonesmusculosperoneos"] = "TENDONES MÚSCULOS PERONEOS"; 
estructurasTxt["peronemaleolo"] = "PERONÉ MALÉOLO"; 
estructurasTxt["ligamentoperoneo-calcaneomedio"] = "LIGAMENTO PERONEO CALCÁNEO MEDIO"; 
estructurasTxt["astragalo"] = "HUESO ASTRÁGALO"; 
estructurasTxt["ligamentoperoneo-astragalinoanterior"] = "LIGAMENTO PERONEO-ASTRAGALINO ANTERIOR"; 
estructurasTxt["tibiamaleolo"] = "TIBIA MALÉOLO"; 
estructurasTxt["ligamentotibiocalcaneomedio"] = "LIGAMENTO TIBIO CALCÁNEO MEDIO"; 
estructurasTxt["tendonmusculotibialposterior"] = "TENDÓN MÚSCULO-TIBIAL POSTERIOR"; 
estructurasTxt["vainadelmusculotibialposterior"] = "VAINA DEL MÚSCULO TIBIAL POSTERIOR"; 
estructurasTxt["huesossesamoideos"] = "HUESOS SESAMOIDEOS"; 
estructurasTxt["cabezametatarsiano"] = "CABEZA METATARSIANO"; 
estructurasTxt["tendondelflexorlargodelhallux"] = "TENDÓN DEL FLEXOR LARGO DEL HALLUX"; 
estructurasTxt["tendonesflexorcomundelosdedos"] = "TENDONES FLEXOR COMÚN DE LOS DEDOS"; 
estructurasTxt["cabezatercermetatarsiano"] = "CABEZA DEL TERCER METATARSIANO"; 
estructurasTxt["cabezacuartometatarsiano"] = "CABEZA DEL CUARTO METATARSIANO"; 
estructurasTxt["cabezasegundometatarsiano"] = "CABEZA DEL SEGUNDO METATARSIANO"; 
estructurasTxt["cabezaquintometatarsiano"] = "CABEZA DEL QUINTO METATARSIANO"; 
estructurasTxt["cabezaprimermetatarsiano"] = "CABEZA DEL PRIMER METATARSIANO"; 
estructurasTxt["tuberosidadposteriordelcalcaneo"] = "TUBEROSIDAD POSTERIOR DEL CALCÁNEO"; 
estructurasTxt["tendondeaquiles"] = "TENDÓN DE AQUILES"; 
estructurasTxt["grasadekager"] = "GRASA DE KAGER"; 
estructurasTxt["bursaretroaquilea"] = "BURSA RETROAQUÍLEA"; 
estructurasTxt["tendondelmusculoflexorpropiohallucis"] = "TENDÓN DEL MÚSCULO FLEXOR PROPIO HALLUCIS"; 
estructurasTxt["retinaculodelosflexores"] = "RETINÁCULO DE LOS FLEXORES"; 
estructurasTxt["musculoflexorpropiohallucis"] = "MÚSCULO FLEXOR PROPIO HALLUCIS"; 
estructurasTxt["nerviotibialposterior"] = "NERVIO TIBIAL POSTERIOR"; 
estructurasTxt["venatibialposterior"] = "VENA TIBIAL POSTERIOR"; 
estructurasTxt["arteriatibialposterior"] = "ARTERIA TIBIAL POSTERIOR"; 
estructurasTxt["musculoflexorcomundelosdedos"] = "MÚSCULO FLEXOR COMÚN DE LOS DEDOS"; 
estructurasTxt["tendondelmusculotibialposterior"] = "TENDÓN DEL MÚSCULO TIBIAL POSTERIOR"; 
estructurasTxt["ligamentotibioastragalinoanterior"] = "LIGAMENTO TIBIO-ASTRAGALINO ANTERIOR"; 
estructurasTxt["tendondelflexorcomundelosdedosparaeliii"] = "TENDÓN DEL FLEXOR COMÚN DE LOS DEDOS PARA EL TERCER"; 
estructurasTxt["tendondelflexorcomundelosdedosparaelii"] = "TENDÓN DEL FLEXOR COMÚN DE LOS DEDOS PARA EL SEGUNDO"; 
estructurasTxt["tendondelflexorcomundelosdedosparaeliv"] = "TENDÓN DEL FLEXOR COMÚN DE LOS DEDOS PARA EL CUARTO"; 
estructurasTxt["tendondelflexorcomundelosdedosparaelv"] = "TENDÓN DEL FLEXOR COMÚN DE LOS DEDOS PARA EL QUINTO"; 
estructurasTxt["retinaculodeloseversores"] = "RETINÁCULO DE LOS EVERSORES"; 
estructurasTxt["vientremuscularperoneolateralcorto"] = "VIENTRE MUSCULAR PERONEO LATERAL CORTO"; 
estructurasTxt["tendondelperoneolateralcorto"] = "TENDÓN DEL PERONEO LATERAL CORTO"; 
estructurasTxt["tendondelperoneolaterallargo"] = "TENDÓN DEL PERONEO LATERAL LARGO"; 
estructurasTxt["vainadelostendones"] = "VAINA DE LOS TENDONES"; 
estructurasTxt["huesocuboides"] = "HUESO CUBOIDES"; 
estructurasTxt["tendonplantarlargodelhallux"] = "TENDÓN PLANTAR LARGO DEL HALLUX";
estructurasTxt["apofisiscoronoides "] = "APÓFISIS CORONOIDES";
estructurasTxt["cartilagoarticular "] = "CARTÍLAGO ARTICULAR";
estructurasTxt["fosacoronoidea "] = "FOSA CORONOIDEA";
estructurasTxt["trocleahumeral "] = "TRÓCLEA HUMERAL";
estructurasTxt["vainas"] = "VAINAS";

export {estructurasTxt};
export default caso;